<!-- @format -->
<template>
    <div class="deny-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Details</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div class="step">
                    <p>{{ AgencyName }} has denied your request for the following reason:</p>
                    <p class="description">
                        <strong
                            >Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                            tempor incididunt ut labore et dolore magna aliqua.</strong
                        >
                    </p>
                    <p>You may <strong class="link">submit another request</strong> at anytime.</p>
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-button" @click="closeWidget"> Cancel </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'deny-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {};
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },
};
</script>

<style>
.deny-widget .cname-table .master-table-cell {
    height: auto;
    min-height: 52px;
}

.deny-widget .cname-table .type-cell {
    min-width: 100px;
    max-width: 100px;
}

.deny-widget .cname-table .host-cell,
.deny-widget .cname-table .data-cell {
    min-width: 400px;
    max-width: 400px;
}

.deny-widget .cname-table .host-cell .master-table-cell-content,
.deny-widget .cname-table .data-cell .master-table-cell-content {
    white-space: normal;
    overflow: visible;
    word-break: break-all;
}

.deny-widget .create-records-step,
.deny-widget .validate-records-step,
.deny-widget .loading-step {
    text-align: center;
}

.deny-widget .instructions .instruction {
    margin-top: 25px;
}

.deny-widget .instructions .instruction label {
    display: block;
}

.deny-widget .custom-selector {
    display: flex;
}

.deny-widget .custom-selector .app-checkbox {
    margin-right: 10px;
}

.deny-widget .link {
    color: #18aeff;
    font-weight: 500;
}

.deny-widget .description {
    margin: 25px 0px;
}
</style>
